import angular from 'angular'
import adjustInvoiceCtrl from './adjustInvoiceCtrl'

import { account } from 'redevConfig'

const list = (account && account.list) || ''
const listPage = list ? require(`redevelopment/input/account/${list.templateName}`) : require('./view/list.html')
const accountListCtrl = list ? require(`redevelopment/input/account/${list.controllerName}`) : require('./accountListCtrl.js')
export default angular
    .module('input.financialCounting.account', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('input.financialCounting.account', {
            url: '/account',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'input.financialCounting.account.list',
            title: '财税对账台账',
        })
        $stateProvider.state('input.financialCounting.account.list', {
            url: '/list',
            template: listPage,
            controller: 'accountListCtrl',
        })
    }])
    .controller('accountListCtrl', accountListCtrl.default)
    .controller('adjustInvoiceCtrl', adjustInvoiceCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/input/financialCounting/reconciliationAccount/index.js